$(document).ready(function(){
    const $ = require('jquery');

    global.Tether = require('./vendor/tether.min.js');

    require("./vendor/cookieconsent.min.js");
    require('./custom/jquery.cookieconsent.js');


    require("./vendor/bootstrap.min");
    //require("./vendor/owl.carousel.min");


    require("./custom/main");
    require("./custom/navigation");
    require("./custom/sidebar");
    require("./custom/select");

    require("../../typo3conf/ext/clarunis_torso/Resources/Public/Javascript/torso");
    
    // ToDo: fix jQuery inclusion, #63850
//    require("../../typo3conf/ext/cabag_googlesearch/Resources/Public/JavaScript/search");
    require("./custom/cabag_googlesearch");

    require('../scss/styles.scss');


});
